import { useEffect, useState } from "react";
import Container from "../container";
import logo from ".././../assets/images/logo_header.svg";
import MobileToggleBtn from "./mobile_toggle_btn";

export default function Header({ isOpen, toggleSidebar }) {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const section2 = document.getElementById("what-we-do");
            if (section2) {
                const rect = section2.getBoundingClientRect();
                setIsVisible(rect.top <= 0);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div className={`w-full bg-[#004D99] h-[60px] transition-all duration-300 ${isVisible ? "fixed top-0 left-0 shadow-sm z-50" : "hidden"}`}>
            <Container  className="!px-[30px] lg:px-[40px] 2xl:!px-0">
                <div className="flex h-[60px] w-full justify-between items-center">
                    <img src={logo} alt="logo" width={140} height={49} />
                    <div className="hidden sm:flex items-center gap-[47px] pt-5">
                        <div className="flex flex-col w-max group"
                            onClick={() => {
                                const element = document.getElementById("what-we-do");
                                const offset = 50;

                                if (element) {
                                    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                                    window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
                                }
                            }}
                        >
                            <h3 className="text-[#fff] font-bold text-[15px] uppercase cursor-pointer pb-[14px] group-hover:text-[#EB4A00] transition-colors duration-300">
                                What we do
                            </h3>
                            <div className="h-[4px] w-full bg-[#EB4A00] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        </div>

                        <div className="flex flex-col w-max group"
                            onClick={() => {
                                const element = document.getElementById("our-works");
                                const offset = 80;

                                if (element) {
                                    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                                    window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
                                }
                            }}
                        >
                            <h3 className="text-[#fff] font-bold text-[15px] uppercase cursor-pointer pb-[14px] group-hover:text-[#EB4A00] transition-colors duration-300">
                                Our Works
                            </h3>
                            <div className="h-[4px] w-full bg-[#EB4A00] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        </div>

                        <div className="flex flex-col w-max group"
                            onClick={() => document.getElementById('contacts').scrollIntoView({ behavior: "smooth", duration: 500 })}
                        >
                            <h3 className="text-[#fff] font-bold text-[15px] uppercase cursor-pointer pb-[14px] group-hover:text-[#EB4A00] transition-colors duration-300">
                                Contacts
                            </h3>
                            <div className="h-[4px] w-full bg-[#EB4A00] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        </div>
                    </div>
                    <MobileToggleBtn
                        toggleSidebar={toggleSidebar}
                        isOpen={isOpen}
                    />
                </div>

            </Container>
        </div>
    );
}
